<template>
  <div></div>
</template>

<script>
import { goodsPrivilegeService } from '@/api'
import Body from '@/mixins/body'

// 跳转到单向历
export default {
  name: 'Dxl',
  mixins: [Body],
  methods: {
    // 已有用户时初始化信息
    created_hasToken() {
      this.getGoodsPrivilege()
    },
    getGoodsPrivilege() {
      const devUrl = 'https://new-wx-test.ylyk.com/ylyk/payment.html'
      const proUrl = 'https://new-wx.ylyk.com/ylyk/payment.html'
      const hostUrl = process.env.NODE_ENV === 'production' ? proUrl : devUrl
      /**
       * 活动规则
       * 1. 用户已购买，进入下载页
       * 2. 用户为无限卡，支持99元购买实物 (90358)
       *    用户为非无限卡，支持219购买 (40058)
       */
      goodsPrivilegeService
        .getGoodsPrivilege({
          goodsIdList: [90358, 40058]
        })
        .then(res => {
          let isBuy
          let url
          if (res.isForever) {
            isBuy = res.goodsList.filter(i => i.goodsId === 90358)[0].isBuy
            url = `${hostUrl}?goodsIds=90358#/goods`
          } else {
            isBuy = res.goodsList.filter(i => i.goodsId === 40058)[0].isBuy
            url = `${hostUrl}?goodsIds=40058#/goods`
          }
          if (isBuy) {
            location.href = 'https://download.ylyk.com/ylsn.html'
          } else {
            const link = document.createElement('a')
            link.href = url
            link.click()
          }
        })
    }
  }
}
</script>

<style></style>
